import React from 'react';

const PurchaserOfferContext = React.createContext();
export const PurchaserOfferContextProvider = PurchaserOfferContext.Provider;
export default PurchaserOfferContext;